<ng-container *ngIf="announcements.length">
  <div class="overlay-wrapper" @overlayAnim>

    <section
      class="overlay-card"
      role="dialog"
      aria-modal="true"
      aria-label="Announcements">

      <!-- Header -->
      <header class="overlay-header">
         <h2 class="overlay-title">Announcements</h2> 

        <button
          class="close-btn"
          mat-icon-button
          aria-label="Close announcements"
          (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </header>

      <!-- Scrollable body -->
      <div class="overlay-content" >
        <article
          class="announcement"
          *ngFor="let announcement of announcements; let last = last"
          [class.last]="last">

          <ng-container *ngIf="isVideoAnnouncement(announcement); else normalAnnouncement">

            <!-- MP4 -->
            <video
              *ngIf="isMp4Video(announcement)"
              class="announcement-video"
              [src]="announcement.content"
              controls
              controlsList="nodownload"
              preload="metadata">
            </video>

            <!-- YouTube -->
            <iframe
              *ngIf="isYoutubeVideo(announcement)"
              class="announcement-frame"
              [src]="announcement.youtubeUrl"
              frameborder="0"
              allowfullscreen>
            </iframe>

            <!-- Google Drive -->
<div *ngIf="isDriveVideo(announcement)">
  DRIVE VIDEO DETECTED

  <iframe
    class="announcement-frame"
    [src]="announcement.driveUrl"
    frameborder="0"
    allowfullscreen>
  </iframe>
</div>

          </ng-container>

          <ng-template #normalAnnouncement>
            <div [innerHTML]="announcement.content"></div>
          </ng-template>

        </article>
      </div>

    </section>

  </div>
</ng-container>
